<script>
export default {
    name: 'ImagePlaceholder',
    props: {
        img_url: {
            type: String,
            default: '',
        },
        width: {
            type: String,
            default: '45',
        },
        height: {
            type: String,
            default: '56',
        },
    },
}
</script>

<!-- eslint-disable max-len -->
<template>
    <img v-if="img_url" :src="img_url" :width="width" :height="height" style="object-fit: contain" />
    <svg v-else :width="width" :height="height" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="45" height="45" rx="3" fill="#E8EAF3" />
        <path d="M18.9535 16.125C18.9535 17.8509 17.5414 19.25 15.7994 19.25C14.0575 19.25 12.6453 17.8509 12.6453 16.125C12.6453 14.3991 14.0575 13 15.7994 13C17.5414 13 18.9535 14.3991 18.9535 16.125Z" fill="#ffb53e" />
        <path
            d="M24.284 21.191C24.0412 21.0707 23.7479 21.1178 23.5559 21.3081L19.584 26.304C19.2083 26.7766 18.5026 26.811 18.0827 26.3772L15.5205 23.73C15.2703 23.5647 14.9371 23.5974 14.7245 23.8081L8.381 31.3566C7.8343 32.0072 8.2968 33 9.14657 33H35.3059C36.2332 33 36.6611 31.8472 35.9583 31.2422L24.284 21.191Z"
            fill="#ffb53e"
        />
    </svg>
</template>
